import { render, staticRenderFns } from "./DocumentExampleModal.vue?vue&type=template&id=3973b928&"
import script from "./DocumentExampleModal.vue?vue&type=script&lang=js&"
export * from "./DocumentExampleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports